import { ScoreCategory, ScoreModuleState } from './TreamsScore.types';
import type { ScoreModuleStatus, TreamsCategoryScore, TreamsScore } from './TreamsScore.types';
import { SCORE_WEIGHTS } from './config/score-weights';

const round1 = (value: number): number => Math.round(value * 10) / 10;

export const adjustScoresForModuleStatus = (
	scores: TreamsScore,
	status: ScoreModuleStatus,
): TreamsScore => {
	const categories = Object.keys(SCORE_WEIGHTS) as ScoreCategory[];

	const adjusted = {} as Record<ScoreCategory, TreamsCategoryScore>;

	let weightedScore = 0;
	let weightedDelta = 0;
	let totalWeight = 0;

	for (const category of categories) {
		const isEnabled = status[category] === ScoreModuleState.Enabled;
		const score = isEnabled ? scores[category].score : 0;
		const delta = isEnabled ? scores[category].delta : 0;

		adjusted[category] = { score, delta };

		const weight = SCORE_WEIGHTS[category];

		weightedScore += score * weight;
		weightedDelta += delta * weight;
		totalWeight += weight;
	}

	const total: TreamsCategoryScore =
		totalWeight === 0
			? { score: 0, delta: 0 }
			: {
					score: round1(weightedScore / totalWeight),
					delta: round1(weightedDelta / totalWeight),
				};

	return { ...adjusted, total };
};
